import { render, staticRenderFns } from "./AdditionalInfoButton.vue?vue&type=template&id=9ce9c822"
import script from "./AdditionalInfoButton.vue?vue&type=script&lang=ts"
export * from "./AdditionalInfoButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports